import { Pipe, PipeTransform } from '@angular/core';
import { Material } from '../classes/material.class';
import { getMaterialProperty, MaterialProperty } from './material-property.pipe';

@Pipe({
    name: 'materialProperties',
    standalone: false,
})
export class MaterialPropertiesPipe implements PipeTransform {
    transform(materials: Material[] | null, property: MaterialProperty): string {
        const values = (materials ?? []).map(material => getMaterialProperty(material, property)).filter(Boolean);

        return [...new Set(values)].join(', ');
    }
}
